import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import { FAQ as FAQRouteConstants } from '../../route-constants';
import './faq-nav-desktop.less';

/**
 * Desktop FAQ Navigation
 */
const DesktopNav = ({ label, links }) => (
  <div className='FAQNavDesktop'>
    <span className='header'>{label}</span>
    <ul className='list'>
      {links.map((link) => (
        <li key={link.route}>
          <Link href={`${FAQRouteConstants.BASE_URI}/[topic]`} as={link.route}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className={`link ${link.active ? 'active' : ''}`}>
              {link.text}
            </a>
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

DesktopNav.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    route: PropTypes.string,
    text: PropTypes.string,
    active: PropTypes.bool,
  })).isRequired,
  label: PropTypes.string.isRequired,
};

export default DesktopNav;
